import React from 'react';
import {
  Row,
  Col,
  Button,
  Form,
  FormGroup,
  ControlLabel,
  FormControl
} from 'react-bootstrap';
import { Field, reduxForm } from 'redux-form';
import { CSSTransitionGroup } from 'react-transition-group';
import { formatDate, validateRequired } from '../../helpers';
import Input from '../../components/Input';

class IndustryDetailsForm extends React.Component {
  render() {
    return (
      <div>
        <Row />
        <Form onSubmit={this.props.handleSubmit}>
          <Row>
            <FormGroup>
              <Col sm={12} className="form-input">
                <Field
                  component={Input}
                  type="text"
                  label="Industry name"
                  placeholder="Industry name"
                  name="name"
                  validate={validateRequired}
                />
              </Col>
            </FormGroup>
          </Row>

          {!this.props.isNew && (
            <div>
              <Row>
                <FormGroup>
                  <Col sm={12} className="form-input">
                    <Field
                      component={Input}
                      type="toggle"
                      name="isArchived"
                      label="Active"
                      reverse
                    />
                  </Col>
                </FormGroup>
              </Row>

              <Row>
                <Col sm={12} className="form-input">
                  <ControlLabel>Date created</ControlLabel>
                  <FormControl.Static>
                    {formatDate(this.props.currentIndustry.dateCreated)}
                  </FormControl.Static>
                </Col>
              </Row>
              <Row>
                <Col sm={12} className="form-input">
                  <ControlLabel>Last changed</ControlLabel>
                  <FormControl.Static>
                    {formatDate(this.props.currentIndustry.dateUpdated)}
                  </FormControl.Static>
                </Col>
              </Row>
              <Row>
                <Col sm={12} className="form-input">
                  <ControlLabel>Last changed by</ControlLabel>
                  <FormControl.Static>
                    {this.props.currentIndustry.lastChangedBy}
                  </FormControl.Static>
                </Col>
              </Row>
            </div>
          )}

          <Row>
            <Col sm={2} className="table-header">
              <Button
                bsStyle="primary"
                type="submit"
                disabled={this.props.isSaving}
              >
                {this.props.isSaving ? 'Saving...' : 'Save'}
              </Button>
            </Col>
          </Row>
          <br />
          <Row>
            <Col sm={12}>
              <CSSTransitionGroup
                transitionName="fade"
                transitionEnterTimeout={300}
                transitionLeaveTimeout={300}
              >
                {this.props.successMsg && (
                  <p className="text-success">{this.props.successMsg}</p>
                )}
              </CSSTransitionGroup>
            </Col>
          </Row>
        </Form>
        {this.props.errorMsg && (
          <div className="alert alert-danger">{this.props.errorMsg}</div>
        )}
      </div>
    );
  }
}

// Decorate the form component
IndustryDetailsForm = reduxForm({
  form: 'industryDetailsForm' // a unique name for this form
})(IndustryDetailsForm);

export default IndustryDetailsForm;



// WEBPACK FOOTER //
// ./src/containers/industries/IndustryDetailsForm.js